let keyPair: CryptoKeyPair | null = null;
let publicKeyBase64: string | null = null;

export const keyPairReady: Promise<void> = (async () => {
  keyPair = await window.crypto.subtle.generateKey(
    {
      name: 'RSA-OAEP',
      modulusLength: 2048,
      publicExponent: new Uint8Array([1, 0, 1]),
      hash: 'SHA-256',
    },
    false, // private key NOT extractable — cannot be serialized or read from JS
    ['decrypt']
  );
  const spki = await window.crypto.subtle.exportKey('spki', keyPair.publicKey);
  publicKeyBase64 = btoa(String.fromCharCode(...new Uint8Array(spki)));
})();

export function getPublicKeyBase64(): string | null {
  return publicKeyBase64;
}

export async function decryptData(
  encryptedData: string,
  encryptedKey: string,
  iv: string
): Promise<string> {
  await keyPairReady;

  const aesKeyBytes = await window.crypto.subtle.decrypt(
    { name: 'RSA-OAEP' },
    keyPair!.privateKey,
    Uint8Array.from(atob(encryptedKey), (c) => c.charCodeAt(0))
  );

  const aesKey = await window.crypto.subtle.importKey(
    'raw',
    aesKeyBytes,
    { name: 'AES-CBC' },
    false,
    ['decrypt']
  );

  const decryptedBytes = await window.crypto.subtle.decrypt(
    { name: 'AES-CBC', iv: Uint8Array.from(atob(iv), (c) => c.charCodeAt(0)) },
    aesKey,
    Uint8Array.from(atob(encryptedData), (c) => c.charCodeAt(0))
  );

  return new TextDecoder().decode(decryptedBytes);
}
